import React, { useCallback } from 'react'
import { useDispatch } from 'hooks/use-redux'
import { previousTrack } from '@disco/state-management/actions/MediaActions'
import PlayerButton from 'components/common/player/player-button'

/**
 * Player previous track button component
 * Dispatches action to skip to the previous track in the current playlist or queue
 */
const PlayerPrev = (): any => {
  const dispatch = useDispatch()
  const handleClick = useCallback(() => {
    dispatch(previousTrack())
  }, [dispatch])
  return <PlayerButton onClick={handleClick} type="skip-back" />
}

export default PlayerPrev
